import { GISService } from '../gisServicesTypes';

export const getGISLayerID = (gisService: GISService) => {
  const type =
    gisService?.service_type > -1 ? `-${gisService.service_type}` : '';
  const id = gisService?.id > -1 ? `-${gisService.id}` : '';
  return `gis-service${type}${id}`;
};
